import { Alert, Typography } from '@mui/joy';
import { Warning, WarningCircle } from '@phosphor-icons/react';

import { QuoteEntityType, QuoteStatus } from 'quotes/enums';
import { IProjectSubmitBlock, IProjectSubmitWarning } from 'quotes/types';
import { Color, Level, Size, Variant } from 'theme/enums';

import { canOrderStillBeSubmitted } from './quoteStatus';

interface IProps {
  projectSubmitBlock?: IProjectSubmitBlock | null;
  projectSubmitWarning?: IProjectSubmitWarning | null;
  quoteEntityType: QuoteEntityType;
  quoteStatus: QuoteStatus;
  externalOrderNumber?: string | null;
}

const ICON_STYLE = { width: 24, height: 24 };

// The BE sends null for quotes and outside the pre-submit statuses; gating on whether the order
// can still be submitted is defence in depth, so an order nobody will submit again never shows it.
export const OrderProjectSubmitBanner = ({
  projectSubmitBlock,
  projectSubmitWarning,
  quoteEntityType,
  quoteStatus,
  externalOrderNumber = null,
}: IProps) => {
  if (!canOrderStillBeSubmitted(quoteEntityType, { status: quoteStatus, externalOrderNumber })) {
    return null;
  }

  const isBlocked = !!projectSubmitBlock?.message;
  const message = isBlocked ? projectSubmitBlock.message : projectSubmitWarning?.message;

  if (!message) {
    return null;
  }

  return (
    <Alert
      role="alert"
      startDecorator={
        isBlocked ? <WarningCircle style={ICON_STYLE} /> : <Warning style={ICON_STYLE} />
      }
      variant={Variant.SOFT}
      color={isBlocked ? Color.DANGER : Color.WARNING}
      size={Size.LG}
      sx={{
        alignItems: 'flex-start',
        flexShrink: 0,
        mb: '16px',

        '& .MuiAlert-startDecorator': {
          marginTop: '2px',
        },
      }}
    >
      <Typography level={Level.BODY_SM}>{message}</Typography>
    </Alert>
  );
};
